import { render, staticRenderFns } from "./id.vue?vue&type=template&id=3e2d8415&lang=pug&"
import script from "./id.vue?vue&type=script&lang=js&"
export * from "./id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2d8415')) {
      api.createRecord('3e2d8415', component.options)
    } else {
      api.reload('3e2d8415', component.options)
    }
    module.hot.accept("./id.vue?vue&type=template&id=3e2d8415&lang=pug&", function () {
      api.rerender('3e2d8415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sample/sample/id.vue"
export default component.exports